import { LoadingButton } from '@mui/lab';
import { Alert, FormHelperText, List, ListItemButton, ListItemText, MenuItem, OutlinedInput, Select, Stack, Typography, } from '@mui/material';
import { setAutocolonSelectItem } from 'app/actions/transport';
import { Scrollbar } from 'app/components';
import { autocolonNotSelectedItemsTransportSelector, autocolonSelectedItemTransportSelector, divisionItemsTransportSelector, } from 'app/selectors/transport';
import { useAsyncAction } from 'app/services';
import { deleteDivisionAutocolon, updateDivisionAutocolon } from 'app/store/transport';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const DivisionAutocolonEditBlock = () => {
    const [isUpdate, setIsUpdate] = useState(false);
    const dispatch = useDispatch();
    const autocolonSelectedItem = useSelector(autocolonSelectedItemTransportSelector);
    const autocolons = useSelector(autocolonNotSelectedItemsTransportSelector);
    const divisions = useSelector(divisionItemsTransportSelector);
    const [selectedDivision, setSelectedDivision] = useState(null);
    const [name, setName] = useState(null);
    const [type, setType] = useState(null);
    const [selectedAutocolons, setSelectedAutocolons] = useState([]);
    const [unselectedAutocolons, setUnselectedAutocolons] = useState([]);
    const handleChangeDivision = (e) => {
        setIsUpdate(true);
        setSelectedDivision(e.target.value);
    };
    const handleChangeName = (e) => {
        setIsUpdate(true);
        setName(e.target.value);
    };
    const { asyncAction: updateAutocolon, isLoading: isUpdateAutocolonLoading, isSuccessful: isUpdateAutocolonSuccessful, isError: isUpdateAutocolonError, } = useAsyncAction(updateDivisionAutocolon, [autocolonSelectedItem]);
    const { asyncAction: deleteAutocolon, isLoading: isDeleteAutocolonLoading, isSuccessful: isDeleteAutocolonSuccessful, isError: isDeleteAutocolonError, } = useAsyncAction(deleteDivisionAutocolon, [autocolonSelectedItem]);
    useEffect(() => {
        var _a;
        if (!autocolonSelectedItem)
            return;
        setName(autocolonSelectedItem.name);
        if (autocolonSelectedItem.autocolons && !autocolonSelectedItem.id_division) {
            setType('division');
            setSelectedAutocolons(autocolonSelectedItem.autocolons);
        }
        else {
            setType('autocolon');
            setSelectedDivision((_a = autocolonSelectedItem.id_division) !== null && _a !== void 0 ? _a : null);
        }
    }, [autocolonSelectedItem]);
    const handleDelete = () => {
        deleteAutocolon({
            id: autocolonSelectedItem.id,
            type,
            selectedAutocolons,
        });
        setIsUpdate(false);
    };
    const handleUpdateAutocolon = () => {
        updateAutocolon({
            name,
            id_division: selectedDivision,
            id: autocolonSelectedItem.id,
            type,
            selectedAutocolons,
            unselectedAutocolons,
        });
        setIsUpdate(false);
    };
    useEffect(() => {
        if (isDeleteAutocolonSuccessful) {
            dispatch(setAutocolonSelectItem(null));
        }
    }, [isDeleteAutocolonSuccessful]);
    const newAutocolons = () => {
        const selectedAutocolonsIds = selectedAutocolons.map((item) => item.id);
        return autocolons.filter((autocolon) => !selectedAutocolonsIds.includes(autocolon.id));
    };
    const handleToggleAutocolon = ({ id, name: autocolonName }) => {
        setIsUpdate(true);
        if (selectedAutocolons.find((item) => item.id === id)) {
            setSelectedAutocolons(selectedAutocolons.filter((item) => item.id !== id));
            if (!autocolons.find((autocolon) => autocolon.id === id)) {
                setUnselectedAutocolons([...unselectedAutocolons, { id, name: autocolonName }]);
            }
            return;
        }
        setSelectedAutocolons([...selectedAutocolons, { id, name: autocolonName }]);
        if (unselectedAutocolons.find((autocolon) => autocolon.id === id)) {
            setUnselectedAutocolons(unselectedAutocolons.filter((item) => item.id !== id));
        }
    };
    return (React.createElement(Scrollbar, null,
        React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                maxWidth: '540px',
                margin: '0 auto',
                width: '100%',
                padding: theme.spacing(2),
                position: 'relative',
                border: '1px solid',
                borderRadius: theme.shape.borderRadius,
                borderColor: theme.palette.divider,
                bgcolor: 'background.paper',
                '.MuiTabPanel-root': {
                    width: '100%',
                    padding: theme.spacing(2),
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    legend: {
                        overflow: 'visible',
                        span: {
                            opacity: 1,
                            bgcolor: '#fff',
                        },
                    },
                },
                '& .MuiTypography-root': {
                    fontSize: '0.8em',
                },
                '& .MuiListItemText-root': {
                    padding: 0,
                    margin: 0,
                },
                '& .MuiListItemButton-root': {
                    padding: '4px 0',
                },
            }) },
            type === 'autocolon' && (React.createElement(React.Fragment, null,
                React.createElement(Stack, { sx: { paddingTop: '10px', width: '100%' } },
                    React.createElement(OutlinedInput, { label: '\u0410\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u0430', notched: true, fullWidth: true, value: name, onChange: handleChangeName, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0410\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B' }),
                    React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")),
                React.createElement(Stack, { sx: { paddingTop: '10px', width: '100%' } },
                    React.createElement(Select, { value: selectedDivision, label: '\u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D', variant: 'outlined', notched: true, fullWidth: true, onChange: handleChangeDivision },
                        React.createElement(MenuItem, { value: 0, key: 0 }, "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u043E\u0442\u043E\u0432\u0441\u0435\u0445"),
                        divisions.map((division) => (React.createElement(MenuItem, { value: division.id, key: division.id }, division.name))))))),
            type === 'division' && (React.createElement(React.Fragment, null,
                React.createElement(Stack, { sx: { paddingTop: '10px', width: '100%' } },
                    React.createElement(OutlinedInput, { label: '\u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D', notched: true, fullWidth: true, value: name, onChange: handleChangeName, placeholder: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0414\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0430' }),
                    React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0438 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432")),
                React.createElement(Stack, { direction: 'row', sx: { width: '100%', marginLeft: '2px' } },
                    React.createElement(Stack, { sx: { paddingTop: '10px', width: '50%' } },
                        React.createElement(Typography, { align: 'left', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B"),
                        React.createElement(List, null, selectedAutocolons.map(({ id, name: autocolonName }) => {
                            return (React.createElement(ListItemButton, { key: id, onClick: () => handleToggleAutocolon({
                                    id,
                                    name: autocolonName,
                                }) },
                                React.createElement(ListItemText, { primary: autocolonName })));
                        }))),
                    React.createElement(Stack, { sx: { paddingTop: '10px', width: '50%' } },
                        React.createElement(Typography, { align: 'left', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u041D\u0435\u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u0430\u0432\u0442\u043E\u043A\u043E\u043B\u043E\u043D\u043D\u044B"),
                        React.createElement(List, null,
                            unselectedAutocolons.map(({ id, name: autocolonName }) => {
                                return (React.createElement(ListItemButton, { key: id, onClick: () => handleToggleAutocolon({
                                        id,
                                        name: autocolonName,
                                    }) },
                                    React.createElement(ListItemText, { primary: autocolonName })));
                            }),
                            newAutocolons().map(({ id, name: autocolonName }) => {
                                return (React.createElement(ListItemButton, { key: id, onClick: () => handleToggleAutocolon({
                                        id,
                                        name: autocolonName,
                                    }) },
                                    React.createElement(ListItemText, { primary: autocolonName })));
                            })))))),
            React.createElement(Stack, { sx: { paddingTop: '10px', width: '100%' } },
                ((!isUpdateAutocolonLoading && isUpdateAutocolonError) || (!isDeleteAutocolonLoading && isDeleteAutocolonError)) && (React.createElement(Alert, { severity: 'error' },
                    "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438",
                    isUpdateAutocolonError && 'обвновлении',
                    isDeleteAutocolonError && 'удалении',
                    ". \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                !isUpdateAutocolonLoading && isUpdateAutocolonSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
            React.createElement(Stack, { direction: 'row', sx: {
                    justifyContent: 'space-between',
                    paddingTop: '20px',
                    width: '100%',
                } },
                React.createElement(LoadingButton, { variant: 'contained', color: 'error', loading: isDeleteAutocolonLoading || isUpdateAutocolonLoading, onClick: handleDelete, disableElevation: true }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"),
                React.createElement(LoadingButton, { variant: 'contained', disabled: !isUpdate, loading: isUpdateAutocolonLoading || isDeleteAutocolonLoading, disableElevation: true, onClick: handleUpdateAutocolon }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F")))));
};
export default DivisionAutocolonEditBlock;
